module.exports = __webpack_public_path__ + "media/images/no_organization-69730d8e7d147876bd9ed329a4c4b0b8.png";